import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import {
  parseJsonValue,
  stringifyJsonValue,
} from '../utils';
import TextFieldField from './TextFieldField';

const JsonField = ({
  data, value, disabled, isDiff, onChange, textPlaceholder, validate, savedError, onValidationChange,
}) => {
  const handleChange = useCallback((nextValue, fieldData, onCancel) => {
    onChange(parseJsonValue(nextValue), fieldData, onCancel);
  }, [onChange]);

  return (
    <TextFieldField
      data={data}
      value={stringifyJsonValue(value)}
      disabled={disabled}
      isDiff={isDiff}
      placeholder={textPlaceholder}
      multiline
      inputProps={{ style: { minHeight: 80 } }}
      validate={validate}
      savedError={savedError}
      onValidationChange={onValidationChange}
      onChange={handleChange}
    />
  );
};

JsonField.propTypes = {
  data: PropTypes.shape({ title: PropTypes.string }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  textPlaceholder: PropTypes.string,
  validate: PropTypes.func,
  savedError: PropTypes.string,
  onValidationChange: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

JsonField.defaultProps = {
  value: '',
  disabled: false,
  isDiff: false,
  textPlaceholder: '',
  validate: null,
  savedError: null,
  onValidationChange: null,
};

export default JsonField;
